export default "__VITE_ASSET__BlWJWzh5__"